import { render, staticRenderFns } from "./BaseMirIcon.vue?vue&type=template&id=706a1277&scoped=true"
import script from "./BaseMirIcon.vue?vue&type=script&lang=js"
export * from "./BaseMirIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706a1277",
  null
  
)

export default component.exports